<template>
    <DModal
        :show="showModal"
        :title="title"
        :message="message"
        is-confirm
        is-error
        @close="closeModal()"
        @confirm="save"
    />
</template>

<script setup>

defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        default: null
    },
    message: {
        type: String,
        default: null
    }
})

const emit = defineEmits(['close-modal', 'confirm-modal'])

const closeModal = () => {
    emit('close-modal')
}

function save () {
    emit('confirm-modal')
}

</script>

<style lang="scss" scoped>

</style>
